/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as StudioRouteImport } from './routes/studio'
import { Route as ShareRouteImport } from './routes/share'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as RefundsRouteImport } from './routes/refunds'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PlansRouteImport } from './routes/plans'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as NoticesRouteImport } from './routes/notices'
import { Route as LoginRouteImport } from './routes/login'
import { Route as BrandsRouteImport } from './routes/brands'
import { Route as IndexRouteImport } from './routes/index'
import { Route as HousesHouseIdRouteImport } from './routes/houses.$houseId'
import { Route as BoardsBoardIdRouteImport } from './routes/boards.$boardId'
import { Route as BoardsBoardIdVisitRouteImport } from './routes/boards.$boardId_.visit'

const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const StudioRoute = StudioRouteImport.update({
  id: '/studio',
  path: '/studio',
  getParentRoute: () => rootRouteImport,
} as any)
const ShareRoute = ShareRouteImport.update({
  id: '/share',
  path: '/share',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const RefundsRoute = RefundsRouteImport.update({
  id: '/refunds',
  path: '/refunds',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const PlansRoute = PlansRouteImport.update({
  id: '/plans',
  path: '/plans',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const NoticesRoute = NoticesRouteImport.update({
  id: '/notices',
  path: '/notices',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const BrandsRoute = BrandsRouteImport.update({
  id: '/brands',
  path: '/brands',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const HousesHouseIdRoute = HousesHouseIdRouteImport.update({
  id: '/houses/$houseId',
  path: '/houses/$houseId',
  getParentRoute: () => rootRouteImport,
} as any)
const BoardsBoardIdRoute = BoardsBoardIdRouteImport.update({
  id: '/boards/$boardId',
  path: '/boards/$boardId',
  getParentRoute: () => rootRouteImport,
} as any)
const BoardsBoardIdVisitRoute = BoardsBoardIdVisitRouteImport.update({
  id: '/boards/$boardId_/visit',
  path: '/boards/$boardId/visit',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/brands': typeof BrandsRoute
  '/login': typeof LoginRoute
  '/notices': typeof NoticesRoute
  '/onboarding': typeof OnboardingRoute
  '/plans': typeof PlansRoute
  '/privacy': typeof PrivacyRoute
  '/refunds': typeof RefundsRoute
  '/reset-password': typeof ResetPasswordRoute
  '/settings': typeof SettingsRoute
  '/share': typeof ShareRoute
  '/studio': typeof StudioRoute
  '/terms': typeof TermsRoute
  '/boards/$boardId': typeof BoardsBoardIdRoute
  '/houses/$houseId': typeof HousesHouseIdRoute
  '/boards/$boardId/visit': typeof BoardsBoardIdVisitRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/brands': typeof BrandsRoute
  '/login': typeof LoginRoute
  '/notices': typeof NoticesRoute
  '/onboarding': typeof OnboardingRoute
  '/plans': typeof PlansRoute
  '/privacy': typeof PrivacyRoute
  '/refunds': typeof RefundsRoute
  '/reset-password': typeof ResetPasswordRoute
  '/settings': typeof SettingsRoute
  '/share': typeof ShareRoute
  '/studio': typeof StudioRoute
  '/terms': typeof TermsRoute
  '/boards/$boardId': typeof BoardsBoardIdRoute
  '/houses/$houseId': typeof HousesHouseIdRoute
  '/boards/$boardId/visit': typeof BoardsBoardIdVisitRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/brands': typeof BrandsRoute
  '/login': typeof LoginRoute
  '/notices': typeof NoticesRoute
  '/onboarding': typeof OnboardingRoute
  '/plans': typeof PlansRoute
  '/privacy': typeof PrivacyRoute
  '/refunds': typeof RefundsRoute
  '/reset-password': typeof ResetPasswordRoute
  '/settings': typeof SettingsRoute
  '/share': typeof ShareRoute
  '/studio': typeof StudioRoute
  '/terms': typeof TermsRoute
  '/boards/$boardId': typeof BoardsBoardIdRoute
  '/houses/$houseId': typeof HousesHouseIdRoute
  '/boards/$boardId_/visit': typeof BoardsBoardIdVisitRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/brands'
    | '/login'
    | '/notices'
    | '/onboarding'
    | '/plans'
    | '/privacy'
    | '/refunds'
    | '/reset-password'
    | '/settings'
    | '/share'
    | '/studio'
    | '/terms'
    | '/boards/$boardId'
    | '/houses/$houseId'
    | '/boards/$boardId/visit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/brands'
    | '/login'
    | '/notices'
    | '/onboarding'
    | '/plans'
    | '/privacy'
    | '/refunds'
    | '/reset-password'
    | '/settings'
    | '/share'
    | '/studio'
    | '/terms'
    | '/boards/$boardId'
    | '/houses/$houseId'
    | '/boards/$boardId/visit'
  id:
    | '__root__'
    | '/'
    | '/brands'
    | '/login'
    | '/notices'
    | '/onboarding'
    | '/plans'
    | '/privacy'
    | '/refunds'
    | '/reset-password'
    | '/settings'
    | '/share'
    | '/studio'
    | '/terms'
    | '/boards/$boardId'
    | '/houses/$houseId'
    | '/boards/$boardId_/visit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  BrandsRoute: typeof BrandsRoute
  LoginRoute: typeof LoginRoute
  NoticesRoute: typeof NoticesRoute
  OnboardingRoute: typeof OnboardingRoute
  PlansRoute: typeof PlansRoute
  PrivacyRoute: typeof PrivacyRoute
  RefundsRoute: typeof RefundsRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SettingsRoute: typeof SettingsRoute
  ShareRoute: typeof ShareRoute
  StudioRoute: typeof StudioRoute
  TermsRoute: typeof TermsRoute
  BoardsBoardIdRoute: typeof BoardsBoardIdRoute
  HousesHouseIdRoute: typeof HousesHouseIdRoute
  BoardsBoardIdVisitRoute: typeof BoardsBoardIdVisitRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/studio': {
      id: '/studio'
      path: '/studio'
      fullPath: '/studio'
      preLoaderRoute: typeof StudioRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/share': {
      id: '/share'
      path: '/share'
      fullPath: '/share'
      preLoaderRoute: typeof ShareRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/refunds': {
      id: '/refunds'
      path: '/refunds'
      fullPath: '/refunds'
      preLoaderRoute: typeof RefundsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/plans': {
      id: '/plans'
      path: '/plans'
      fullPath: '/plans'
      preLoaderRoute: typeof PlansRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notices': {
      id: '/notices'
      path: '/notices'
      fullPath: '/notices'
      preLoaderRoute: typeof NoticesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/brands': {
      id: '/brands'
      path: '/brands'
      fullPath: '/brands'
      preLoaderRoute: typeof BrandsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/houses/$houseId': {
      id: '/houses/$houseId'
      path: '/houses/$houseId'
      fullPath: '/houses/$houseId'
      preLoaderRoute: typeof HousesHouseIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/boards/$boardId': {
      id: '/boards/$boardId'
      path: '/boards/$boardId'
      fullPath: '/boards/$boardId'
      preLoaderRoute: typeof BoardsBoardIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/boards/$boardId_/visit': {
      id: '/boards/$boardId_/visit'
      path: '/boards/$boardId/visit'
      fullPath: '/boards/$boardId/visit'
      preLoaderRoute: typeof BoardsBoardIdVisitRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  BrandsRoute: BrandsRoute,
  LoginRoute: LoginRoute,
  NoticesRoute: NoticesRoute,
  OnboardingRoute: OnboardingRoute,
  PlansRoute: PlansRoute,
  PrivacyRoute: PrivacyRoute,
  RefundsRoute: RefundsRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SettingsRoute: SettingsRoute,
  ShareRoute: ShareRoute,
  StudioRoute: StudioRoute,
  TermsRoute: TermsRoute,
  BoardsBoardIdRoute: BoardsBoardIdRoute,
  HousesHouseIdRoute: HousesHouseIdRoute,
  BoardsBoardIdVisitRoute: BoardsBoardIdVisitRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
